import { render, staticRenderFns } from "./CounselingEventNav.vue?vue&type=template&id=34932e6a&"
import script from "./CounselingEventNav.vue?vue&type=script&lang=js&"
export * from "./CounselingEventNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports